/*
 index

 Główny plik strony  
 Renderowanie w miejscu wyznaconym rzez element root
 
 historia: 
  04-2019 JW - start
  04-05-2019 - rezygnacja z redux-react-hook
*/

import React, { Suspense } from "react";

import ReactDOM from "react-dom";

import { Provider } from 'react-redux';

//import { StoreContext } from 'redux-react-hook'; // https://github.com/facebookincubator/redux-react-hook

//import { BrowserRouter, Route, Link } from 'react-router-dom';
import { Router } from "react-router";
import {
  //BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

import { createBrowserHistory } from 'history';

import App from './App';
//const App = React.lazy(() => import('./App'))
import Success from './app/common/Success';
import Failure from './app/common/Failure';
import TestPlatnosci from './app/payment/TestPlatnosci';

import { store, Actions } from './appredux';

import i18n from './cfg/i18n'; // (needs to be bundled ;))

import { I18nextProvider } from 'react-i18next';

import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import DateFnsUtils from '@date-io/date-fns';
import { sendErrorLog } from "./app/common/helpers";
import CONFIG from "./cfg/config";
import Loader from "./app/common/loader/Loader";

//GoogleAnalytics
import ReactGA from 'react-ga';
ReactGA.initialize('G-H8QHTZM0Y2');
ReactGA.pageview(window.location.pathname + window.location.search);

ReactGA.event({
  category: 'Nawigacja',
  action: 'Start'
});



// transfers sessionStorage from one tab to another
var sessionStorage_transfer = function (event: any) {
  if (!event) { event = window.event; } // ie suq
  if (!event.newValue) return;          // do nothing if no value to work with
  if (event.key === 'getSessionStorage') {
    // another tab asked for the sessionStorage -> send it
    localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
    // the other tab should now have it, so we're done with it.
    localStorage.removeItem('sessionStorage'); // <- could do short timeout as well.
  } else if (event.key === 'sessionStorage' && !sessionStorage.length) {
    // another tab sent data <- get it
    var data = JSON.parse(event.newValue);
    for (var key in data) {
      sessionStorage.setItem(key, data[key]);
    }
  }
};

// listen for changes to localStorage
if (window.addEventListener) {
  window.addEventListener("storage", sessionStorage_transfer, false);
}
// else {
//   window.attachEvent("onstorage", sessionStorage_transfer);
// };


// Ask other tabs for session storage (this is ONLY to trigger event)
if (!sessionStorage.length) {
  localStorage.setItem('getSessionStorage', 'foobar');
  localStorage.removeItem('getSessionStorage');
};

const hist = createBrowserHistory();

//PM 2021-10-26
window.onerror = async (msg, url, line, col, error) => {
  // Note that col & error are new to the HTML 5 spec and may not be 
  // supported in every browser.  It worked for me in Chrome.
  var extra = !col ? '' : '\ncolumn: ' + col;
  extra += !error ? '' : '\nerror: ' + error;

  const log = "Error: " + msg + "\nurl: " + url + "\nline: " + line + extra

  // You can view the information in an alert to see things working like this:
  console.error(log);

  // Report this error via ajax so you can keep track
  //       of what pages have JS issues
  await sendErrorLog('0', '-1', (log.length > 50 ? log.substring(0, 50) : log))
  await store.dispatch(Actions.pageState.addFcmLogMessage(log.length > 50 ? log.substring(0, 50) : log, 2))

  var suppressErrorAlert = true;
  // If you return true, then error alerts (like in older versions of 
  // Internet Explorer) will be suppressed.
  return suppressErrorAlert;
};

window.onunhandledrejection = (e: PromiseRejectionEvent) => {
  console.error(e);
  throw new Error(e.reason.stack);
}

ReactDOM.render(
  <I18nextProvider i18n={i18n as any}>
    <Provider store={store}>
      <Router history={hist}>
        <Suspense fallback={<Loader/>}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            {/*<App/> zakomentować, route odkomentować */}
            {/* */}
            <Switch>
              <Route path="/vscHotelBook/hotel/success" render={(props) => <Success />} />
              <Route path="/vscHotelBook/hotel/failure" render={(props) => <Failure />} />
              <Route path="/vscHotelBook/hotel/testPlatnosci" component={TestPlatnosci} />
              <Route path="/" render={(props) => <App />} />
              {/* <Route path="/" component={App} /> */}
            </Switch>
          </MuiPickersUtilsProvider>
        </Suspense>
      </Router>
    </Provider>
  </I18nextProvider>
  ,
  document.getElementById('root')
);
/*
import * as serviceWorker from "./serviceWorker"
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
*/